import {
  getEmbeddableItem as publicGetEmbeddableItem,
  listEmbeddableItems as publicListEmbeddableItems,
} from './ricos-v1-embeddable-item-ricos-embeddables.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getEmbeddableItem: MaybeContext<
  BuildRESTFunction<typeof publicGetEmbeddableItem> &
    typeof publicGetEmbeddableItem
> = /*#__PURE__*/ createRESTModule(publicGetEmbeddableItem);
export const listEmbeddableItems: MaybeContext<
  BuildRESTFunction<typeof publicListEmbeddableItems> &
    typeof publicListEmbeddableItems
> = /*#__PURE__*/ createRESTModule(publicListEmbeddableItems);

export { ItemType } from './ricos-v1-embeddable-item-ricos-embeddables.universal.js';
export {
  EmbeddableItem,
  EmbeddableItemItemTypeDetailsOneOf,
  PricingData,
  BookingDetails,
  EventDetails,
  GetEmbeddableItemRequest,
  GetEmbeddableItemResponse,
  ListEmbeddableItemsRequest,
  CursorPaging,
  ListEmbeddableItemsResponse,
  PagingMetadataV2,
  Cursors,
  ListEmbeddableItemsOptions,
} from './ricos-v1-embeddable-item-ricos-embeddables.universal.js';
export { ItemTypeWithLiterals } from './ricos-v1-embeddable-item-ricos-embeddables.universal.js';
